<template>
    <div>
        <div class="tw-mb-8">
            <div
                class="tw-grid tw-grid-cols-12 tw-bg-gray-50 tw-pt-3 tw-pb-3 tw-mb-8 tw-rounded-lg tw-uppercase"
            >
                <div class="tw-col-span-6 tw-font-semibold tw-pl-4">
                    {{ $t("teamDashboard.goalsTitle") }}
                </div>
                <div class="tw-col-span-4 color-grey">
                    {{ $t("teamDashboard.goalsStatus") }}
                </div>
                <div class="tw-col-span-2 color-grey">
                    {{ $t("teamDashboard.goalsProgress") }}
                </div>
            </div>

            <l-skeleton-loader v-if="isLoading" />

            <div v-else-if="!goalStatsList.length" class="tw-text-gray-400">
                {{ $t("teamDashboard.goalsEmpty") }}
            </div>

            <div v-else>
                <div v-for="type in types" :key="type">
                    <div v-if="goals[type].length">
                        <div v-for="goal in goals[type]" :key="JSON.stringify(goal._id)">
                            <l-goal-stat-list-item :goal="goal" @click="showGoalsList" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LSkeletonLoader from "@/components/LSkeletonLoader";
import LGoalStatListItem from "@/components/LGoalStatListItem";

export default {
    components: {
        LSkeletonLoader,
        LGoalStatListItem,
    },
    props: {
        user: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            isLoading: true,
            types: ["goalTeam", "goalLocalTeam", "goalUser"],
        };
    },
    computed: {
        ...mapGetters({
            goalStatsList: "goals/goals/statsList",
            goalStatsGlobal: "goals/goals/statsGlobal",
        }),
        goals() {
            const list = {};

            this.types.forEach(type => {
                list[type] = this.goalStatsList.filter(item => item.type === type);
            });

            return list;
        },
    },
    mounted() {
        this.loadData();
    },
    methods: {
        async loadData() {
            this.isLoading = true;

            try {
                await this.$store.dispatch("goals/goals/getList", {
                    payload: {
                        listCustomFilter: {},
                        listSegment: "reports",
                        output: "stats",
                    },
                });
            } finally {
                this.isLoading = false;
            }
        },
        showGoalsList({ segment = "all", filters = [] }) {
            const qs = Object.entries(
                filters.reduce((map, filter) => {
                    if (!map[filter.type]) {
                        map[filter.type] = [];
                    }
                    map[filter.type].push(filter.value);
                    return map;
                }, {}),
            )
                .map(entry => `${entry[0]}=${entry[1].join(",")}`)
                .join("&");

            this.$emit("section", "list");
            this.$router.push(`/goals/list/${segment}/?${qs}`);

            window.scrollTo({ top: 0, behavior: "smooth" });
        },
    },
};
</script>
